import React from "react";
import { Stack } from "@mui/material";
import useJiraSetupApi from "src/scenes/integrations/jira-setup/use-setup-api";
import SelectProjectsAutocomplete from "src/scenes/integrations/jira-setup/projects-autocomplete";
import { LoadingButton } from "@mui/lab";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";
import EnvironmentSelect from "src/components/environment-select";

const JiraSetup = () => {
    const [loading, setLoading] = React.useState(false);
    const [projects, setProjects] = React.useState([]);
    const [projectNames, setProjectNames] = React.useState([]);
    const [projectsToSetup, setProjectsToSetup] = React.useState([]);

    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);

    const jiraSetupApi = useJiraSetupApi();

    React.useEffect(() => {
        if (jiraSetupApi && jiraSetupApi.status && jiraSetupApi.status === "SUCCESS") {
            setProjects(jiraSetupApi.data);
            const namesArray = jiraSetupApi.data.map((project) => project.name);
            setProjectNames(namesArray);
        }
    }, [jiraSetupApi.status]);

    const handleSaveSetup = async () => {
        setLoading(true);
        const createSetupArray = () => {
            return projectsToSetup.map(({ name, fields }) => {
                const project = projects.find((proj) => proj.name === name);
                return {
                    jiraId: fields.id,
                    jiraName: fields.name,
                    adadotName: "bugs_env",
                    projectId: project.id,
                };
            });
        };
        const setupArray = { fields: createSetupArray() };
        try {
            await request(`/api/jira/setup`, {
                method: "POST",
                body: JSON.stringify(setupArray),
            });
            setMessage(`Jira setup saved successfully.`);
            setSeverity("success");
            setIsToastTriggered(true);
            setLoading(false);
        } catch {
            setLoading(false);
            setMessage(`Failed to save Jira setup. Please try again.`);
            setSeverity("warning");
            setIsToastTriggered(true);
        }
    };

    const validateFields = () => {
        return projectsToSetup.some((item) => Object.keys(item.fields).length === 0);
    };

    const findFieldsByProjectName = ({ name }) => {
        const project = projects.find((x) => x.name === name);
        return project ? project.fields : null;
    };

    return (
        <Stack
            direction="column"
            style={{ width: "100%" }}
            mb={4}
            pr={5}
            spacing={3}
            alignItems="flex-end"
        >
            <SelectProjectsAutocomplete
                data={jiraSetupApi && jiraSetupApi.data}
                projectNames={projectNames}
                projectsToSetup={projectsToSetup}
                setProjectsToSetup={setProjectsToSetup}
                projects={projects}
            />
            {projectsToSetup &&
                projectsToSetup.map((project) => {
                    return (
                        <Stack
                            direction="row"
                            key={project.name}
                            spacing={2}
                            style={{ width: "100%" }}
                            justifyContent="space-between"
                        >
                            <p>{project.name}</p>
                            <EnvironmentSelect
                                fields={findFieldsByProjectName({ name: project.name })}
                                projectsToSetup={projectsToSetup}
                                setProjectsToSetup={setProjectsToSetup}
                                projectName={project.name}
                            />
                        </Stack>
                    );
                })}
            <LoadingButton
                variant="contained"
                size="medium"
                disabled={projectsToSetup.length === 0 || validateFields()}
                loading={loading}
                style={{ width: "158px" }}
                onClick={() => {
                    handleSaveSetup();
                }}
            >
                Save Setup
            </LoadingButton>
        </Stack>
    );
};

export default JiraSetup;
